/**
 * BOC
 * Support#138967-Filters Logic
 * author Maanik Arya
 * date 21-Jun-2023
 * use_of_code:- This code is used to show the top filters on mobile view.
 * Created a new component MobileCatalogTopFilter component which is used to show the top filters on mobile view.
 */
import React from "react";
import "./MobileCatalogTopFilter.css";
import MobileCatalogFilter from "./MobileCatalogFilter";
import {
    decodeFiltersFromQueryString,
    mergeAppliedFilters,
    removeFilters,
  } from "../../utils/UtilityMethod";

function MobileCatalogTopFilter({cbCallback , filters , filterQs , sortOptions , sortCallback , searchParams}){

    /**
     * BOC
     * Support#138967-Filters Logic
     * author Maanik Arya
     * date 21-Jun-2023
     * use_of_code:- The onFilterCbClick is used to handle the filter functionality.
     * We have passed the data_val in the onFilterCbClick function which is used to get the filter data.
    */
    const onFilterCbClick = (item, isChecked) => {
        decodeFiltersFromQueryString(filterQs).then((data) => {
          if (isChecked) {
            mergeAppliedFilters(data, item).then((res) => {
              cbCallback(res);
            });
          } else {
            removeFilters(data, item).then((res) => {
              cbCallback(res);
            });
          }
        });
      };

    return (
        <>
            <div class="categories-scrollable-header">
                <div class="fixed-btn">
                    <MobileCatalogFilter
                        cbCallback={cbCallback}
                        filters={filters}
                        searchParams={searchParams}
                        filterQs={filterQs}
                        sortOptions={sortOptions}
                        sortCallback={sortCallback}
                    />
                </div>
                { /* Added class "scrolled" which is responsible for adding the inner shadow*/ } 
                <div class="scrollable-area scrolled">
                    <ul class="categories-list">
                        <li>
                            <a class="active">Refine</a>
                        </li>
                        {filters.map((filter) => {
                            return (
                            <>
                                { filter?.topfilter === 'yes' && (
                                <>
                                    { (filter.header_items?.length === 1 && filter.id !== 'size') ? (
                                        filter.header_items[0].items?.map((item) => {
                                            
                                            var cbItemTitle = filter?.name + "|" + filter?.id || "";
                                            var data_val = JSON.stringify({
                                                choice_type: filter?.choice_type,
                                                title: cbItemTitle,
                                                items: [
                                                    {
                                                        id: item?.id,
                                                        name: item?.name,
                                                        url_slug: item?.url_slug,
                                                    },
                                                ],
                                            });
                                            return (
                                                <>
                                                    <li>
                                                        <a style={item?.selected == 'yes' ? {color:"black",fontWeight:"bolder"} : {}}
                                                        data-val={data_val} 
                                                        onClick={
                                                            (e) => {
                                                                onFilterCbClick(JSON.parse(data_val),item?.selected == 'yes'? false : true)
                                                            }
                                                        }
                                                        >
                                                            {item?.name || ""}
                                                        </a>
                                                    </li>
                                                </>
                                            )
                                        })
                                        )  : (
                                            <>
                                            {filter.header_items?.map((headerItems1) => { 
                                                return(
                                                    <>

                                                    {/** Size  */}
                                                    {/* { console.log("headerItems1" , headerItems1) } */}
                                                    {headerItems1.header_items && 
                                                    (headerItems1.header_items.length > 0 ? 
                                                        <>    
                                                        {headerItems1?.header_items?.map((headerItems2) => {
                                                            return (
                                                                <>
                                                                    {headerItems2?.items?.map((headerItems3) => {
                                                                        var cbItemTitle = filter?.name + "|" + filter?.id || "";
                                                                        var data_val = JSON.stringify({
                                                                            choice_type: filter?.choice_type,
                                                                            title: cbItemTitle,
                                                                            items: [
                                                                                {
                                                                                    id: headerItems3?.id,
                                                                                    name: headerItems3?.name,
                                                                                    url_slug: headerItems3?.url_slug,
                                                                                },
                                                                            ],
                                                                        });
                                                                        return (
                                                                            <>
                                                                                <li>
                                                                                    <a
                                                                                    data-val={data_val} 
                                                                                    onClick={
                                                                                        (e) => {
                                                                                            onFilterCbClick(JSON.parse(data_val),true)
                                                                                        }
                                                                                    }
                                                                                    >
                                                                                        {headerItems3?.name || ""}
                                                                                    </a>
                                                                                </li>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </>
                                                            );
                                                        }
                                                        )}
                                                        </>

                                                    : 
                                                    
                                                    <>
                                                        {headerItems1?.items?.map((headerItems2) => {
                                                            var cbItemTitle = filter?.name + "|" + filter?.id || "";
                                                            var data_val = JSON.stringify({
                                                                choice_type: filter?.choice_type,
                                                                title: cbItemTitle,
                                                                items: [
                                                                    {
                                                                        id: headerItems2?.id,
                                                                        name: headerItems2?.name,
                                                                        url_slug: headerItems2?.url_slug,
                                                                    },
                                                                ],
                                                            });
                                                            return (
                                                                <>
                                                                    <li>
                                                                        <a
                                                                        data-val={data_val} 
                                                                        onClick={
                                                                            (e) => {
                                                                                onFilterCbClick(JSON.parse(data_val),true)
                                                                            }
                                                                        }
                                                                        >
                                                                            {headerItems2?.name || ""}
                                                                        </a>                    
                                                                    </li>
                                                                </>
                                                            );
                                                        })}
                                                    </>
                                                    
                                                    )}
                                                    {/** Size */}




                                                    {/*  Category Type Section Starts */}
                                                    {headerItems1?.items?.map((headerItems2) => {
                                                        var cbItemTitle = filter?.name + "|" + filter?.id || "";
                                                        var data_val = JSON.stringify({
                                                            choice_type: filter?.choice_type,
                                                            title: cbItemTitle,
                                                            items: [
                                                                {
                                                                    id: headerItems2?.id,
                                                                    name: headerItems2?.name,
                                                                    url_slug: headerItems2?.url_slug,
                                                                },
                                                            ],
                                                        });
                                                        return (
                                                            <>
                                                                <li>
                                                                    <a
                                                                    data-val={data_val} 
                                                                    onClick={
                                                                        (e) => {
                                                                            onFilterCbClick(JSON.parse(data_val),true)
                                                                        }
                                                                    }
                                                                    >
                                                                        {headerItems2?.name || ""}
                                                                    </a>
                                                                </li> 
                                                            </>
                                                        );
                                                    }
                                                    )}
                                                    {/* Category Type Section Ends*/}
                                                    </>
                                                )
                                            })}
                                            </>
                                        )
                                    }
                                </>
                                )}
                            </>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </>
    );

}


export default MobileCatalogTopFilter;